module.exports = __webpack_public_path__ + "static/media/047.614c6627.jpg";